import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import { mediaQuerySmallScreen } from '../../theme';

const styles = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
  },
  rowReverse: {
    flexDirection: 'row-reverse',
  },
  noExpand: {
    flex: 'none',
  },
  rowWrap: {
    flexWrap: 'wrap',
  },
  [mediaQuerySmallScreen]: {
    responsiveRow: {
      flexDirection: 'column',
    },
  },
};

const Row = ({
  className,
  classes,
  style = {},
  children,
  noExpand,
  responsive,
  reverse,
  wrap,
  ...otherProps
}) => {
  return (
    <div
      className={classNames(
        className,
        classes.row,
        noExpand ? classes.noExpand : undefined,
        responsive ? classes.responsiveRow : undefined,
        reverse ? classes.rowReverse : undefined,
        wrap ? classes.rowWrap : undefined
      )}
      style={style}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export default injectSheet(styles)(Row);
